module.exports = "<div class=\"wrapper\">\n    <div id=\"algebraTools\"  class=\"status-mts\">\n        <dskl-wb-algebra-tools (onDrawMathRow)=\"onDrawMathRow()\" (onTool)=\"onTool($event)\"></dskl-wb-algebra-tools>\n    </div>\n    <div #rowsEl id=\"math-div\">\n\n        <span class='wb-formula' [id]=\"'wb-formula'+a\" *ngFor=\"let i of rows; let a = index\" (click)=\"currentRow=a\">\n        </span>\n\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/algebra/algebra-wb.component.html
// module id = ../../../../../src/app/wb/algebra/algebra-wb.component.html
// module chunks = main